var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaArriba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75023 18.75H24.2502C24.478 18.7493 24.7013 18.6865 24.8961 18.5683C25.0908 18.4501 25.2497 18.2811 25.3555 18.0793C25.4613 17.8776 25.5101 17.6508 25.4966 17.4234C25.4831 17.196 25.4079 16.9766 25.279 16.7888L14.029 0.53876C13.5627 -0.13499 12.4402 -0.13499 11.9727 0.53876L0.722729 16.7888C0.59251 16.9762 0.516147 17.1957 0.501935 17.4235C0.487724 17.6513 0.536209 17.8786 0.642121 18.0808C0.748034 18.2829 0.907324 18.4522 1.10268 18.5702C1.29804 18.6882 1.522 18.7504 1.75023 18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaArriba);
export default __webpack_public_path__ + "static/media/flechaArriba.ed5deed8f6483adad3718dcf44cdcd37.svg";
export { ForwardRef as ReactComponent };